module.exports = __webpack_public_path__ + "1642699981952/static/media/banner_candidate_jobs_mobile.3e17068d.svg";